/**
 * Spanish (Español) language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_ES_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Live Tracking',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': 'Mi perfil',
    'lvt.menu.tw_profile': 'Perfil TW',
    'lvt.menu.company_profile': 'Perfil de la compañía',
    'lvt.menu.my_notifications': 'Mis notificaciones',
    'lvt.menu.sign_out': 'Cerrar sesión',

    // footer
    'lvt.footer.back_to_top': 'Volver arriba',
    'lvt.footer.terms_of_use': 'Condiciones de uso',
    'lvt.footer.privacy_policy': 'Política de privacidad',
    'lvt.footer.support_information': 'Información de asistencia',
    'lvt.footer.transwide_home': 'Página de inicio de Transwide',
    'lvt.footer.license_nr': 'Núm. de matrícula:',
    'lvt.footer.build_version': 'Versión',

    // order list columns
    'lvt.order_list.header': 'Lista de pedidos',
    'lvt.order_list.column.shipperCompany': 'Empresa cargadora',
    'lvt.order_list.column.reference': 'Referencia',
    'lvt.order_list.column.status': 'Estado',
    'lvt.order_list.column.statusReason': 'Razón del estado',
    'lvt.order_list.column.senderCompany': 'Empresa emisora',
    'lvt.order_list.column.senderZipcode': 'Código zip del emisor',
    'lvt.order_list.column.senderCity': 'Ciudad del emisor',
    'lvt.order_list.column.receiverCompany': 'Empresa receptora',
    'lvt.order_list.column.receiverZipcode': 'Código zip del receptor',
    'lvt.order_list.column.receiverCity': 'Ciudad del receptor',
    'lvt.order_list.column.carrierName': 'Nombre del transportista',
    'lvt.order_list.column.plannedPickupEndDate': 'Recogida planificada',
    'lvt.order_list.column.etaPickup': 'ETA en la recogida',
    'lvt.order_list.column.delayAtPickup': 'Retraso en la recogida',
    'lvt.order_list.column.plannedDeliveryEndDate': 'Entrega planificada',
    'lvt.order_list.column.etaDelivery': 'ETA en la entrega',
    'lvt.order_list.column.delayAtDelivery': 'Retraso en la entrega',
    'lvt.order_list.column.timestamps': 'Marcas horarias',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': 'Solicitado',
    'lvt.order_list.status.failed': 'Error',
    'lvt.order_list.status.waiting': 'Esperando',
    'lvt.order_list.status.active': 'Activo',
    'lvt.order_list.status.stopped': 'Error',
    'lvt.order_list.status.completed': 'Completado',
    'lvt.order_list.status.cancelled': 'Cancelado',
    'lvt.order_list.status.timeout': 'Interrumpido',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': 'Transportista no asignado',
    'lvt.order_list.status_reason.plate_number_not_present': 'Número de matrícula no presente',
    'lvt.order_list.status_reason.plate_number_not_recognized': 'Número de matrícula no reconocido',
    'lvt.order_list.status_reason.plate_number_not_operational': 'Número de matrícula no operativo',
    'lvt.order_list.status_reason.technical_error_not_posted': 'Technical error when creating the tour in GH',

    // pagination
    'lvt.order_list.pagination.rows_per_page': 'filas por página',
    'lvt.order_list.pagination.first': 'Primero',
    'lvt.order_list.pagination.previous': 'Anterior',
    'lvt.order_list.pagination.next': 'Siguiente',
    'lvt.order_list.pagination.last': 'Último',
    'lvt.order_list.pagination.no_orders_found': 'No se han encontrado pedidos',

    // tracked device
    'lvt.map.tracked_device.trailer': 'Remolque',
    'lvt.map.tracked_device.tractor': 'Tractor',
    'lvt.map.tracked_device.mobile': 'Móvil',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': 'Abrir lista de pedidos',
    'lvt.map.traffic_information.traffic': 'Traffic',
    'lvt.map.traffic_information.fast': 'Fast',
    'lvt.map.traffic_information.slow': 'Slow',
    'lvt.map.pickup_popup.pickup': 'Recogida',
    'lvt.map.pickup_popup.date': 'Fecha',
    'lvt.map.pickup_popup.address': 'Dirección',
    'lvt.map.delivery_popup.delivery': 'Entrega',
    'lvt.map.delivery_popup.date': 'Fecha',
    'lvt.map.delivery_popup.address': 'Dirección',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': 'En tránsito para la entrega',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': 'En tránsito para la recogida',
    'lvt.map.current_gps_popup.current_speed': 'Velocidad actual',
    'lvt.map.current_gps_popup.average_speed': 'Velocidad media',
    'lvt.map.current_gps_popup.last_location_update': 'Última actualización de ubicación',
    'lvt.map.current_gps_popup.eta': 'ETA',
    'lvt.map.current_gps_popup.planned_time': 'Hora planificada',
    'lvt.map.current_gps_popup.arrival_delay': 'Retraso en la llegada',
    'lvt.map.current_gps_popup.speed_unit': 'km/h',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': 'Ha llegado al origen',
    'lvt.order_list.timestamp.not_arrived_at_origin': 'No ha llegado al origen',
    'lvt.order_list.timestamp.left_origin': 'Ha salido del origen',
    'lvt.order_list.timestamp.not_left_origin': 'No ha salido del origen',
    'lvt.order_list.timestamp.arrived_at_destination': 'Ha llegado al destino',
    'lvt.order_list.timestamp.not_arrived_at_destination': 'No ha llegado al destino',
    'lvt.order_list.timestamp.left_destination': 'Ha salido del destino',
    'lvt.order_list.timestamp.not_left_destination': 'No ha salido del destino',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-es.ts